<!-- [user_id]="user_id" -->
<app-observation-list-edit
  [p_variety_name]="p_variety_name"
  [p_farmer_name]="p_farmer_name"
  [p_any_date]="p_any_date"
  [p_date_exactly]="p_date_exactly"
  [p_date_init]="p_date_init"
  [p_date_end]="p_date_end"
  [p_month]="p_month"
  [p_user_id]="p_user_id"
  [p_username]="p_username"
  [p_place]="p_place"
  [p_country]="p_country"
  [p_is_original]="p_is_original"
  [p_is_public]="p_is_public"
></app-observation-list-edit>
